'use client';
export { default } from '@corekit/core/src/app/not-found';
